export enum R2Module {
  business = "business",
  businessClient = "business_client",
  businessMessage = "business_message",
  user = "user",
  userSupport = "user_support",
  businessCategory = "business_category",
  canbookTemplateMedia = "canbook_template_media",
}
